import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { AuthService } from '../../../core/services/auth/auth.service'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { TableListSelectComponent } from '../../../shared/components/table-list-select/table-list-select.component'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { MatTabsModule } from '@angular/material/tabs'
import { TableListSelectNewComponent } from '../../../shared/components/table-list-select-new/table-list-select-new.component'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { ModalEmployeeConsultantOperationalClientNotAssociateComponent } from '../modal-employee-consultant-operational-client-not-associate/modal-employee-consultant-operational-client-not-associate.component'

@Component({
  selector: 'modal-employee-consultant-operational-client',
  imports: [
    FormSearchComponent,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    TableListSelectComponent,
    MatButton,
    MatProgressSpinner,
    MatTabsModule,
    TableListSelectNewComponent,
  ],
  templateUrl: './modal-employee-consultant-operational-client.component.html',
  styleUrl: './modal-employee-consultant-operational-client.component.scss',
  standalone: true,
  providers: [EmployeeService],
})
export class ModalEmployeeConsultantOperationalClientComponent
  implements OnInit
{
  constructor(
    private employeeService: EmployeeService,
    private dialogRef: MatDialogRef<ModalEmployeeConsultantOperationalClientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    console.log('this.data', this.data)
    this.idClient = this.data.idClient
    this.multiSelect = data.multiSelect ?? false
    if (this.multiSelect) {
      this.listSelected = data.item
    } else {
      this.selected = data.item
      console.log('this.selected', this.selected)
    }
  }

  multiSelect: boolean = false
  loadingAssociate: boolean = false

  idClient: number = -1

  @Output() responseSingle = new EventEmitter()
  @Output() responseMulti = new EventEmitter()

  listSelected: any[] = []
  selected: any = { id: -1, description: '' }

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'cpf',
      key: 'cpf',
      description: 'Cpf',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
  ]
  screen: string = 'status operação'

  ngOnInit() {
    this.getListItems()
  }

  close() {
    this.dialogRef.close()
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.employeeService
      .listPagedConsultantOperateAssociateByCLientId(
        this.page,
        this.rows,
        this.idClient,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.employeeService
      .searchPagedConsultantOperateAssociateByCLientId(
        this.page,
        this.rows,
        this.searchForm,
        this.idClient,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  selectItem(event: any) {
    if (this.multiSelect) {
      let index = this.listSelected.findIndex((ele) => ele.id == event.id)
      if (index > -1) {
        this.listSelected.splice(index, 1)
      } else {
        this.listSelected.push(event)
      }
    } else {
      if (this.selected.id == event.id) {
        this.selected = { associate: false, id: -1, description: '' }
      } else {
        this.selected = { ...event, id: event.funcionarioId }
      }
    }
  }

  checkForm() {
    if (this.selected.id >= 0 || this.listSelected.length > 0) {
      return true
    } else {
      return false
    }
  }

  removeSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ associate: false })
    } else {
      this.responseSingle.emit({ associate: false })
    }
    this.close()
  }

  confirmSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ associate: true, selection: this.listSelected })
    } else {
      this.responseSingle.emit({
        associate: true,
        selection: { ...this.selected, id: this.selected.funcionarioId },
      })
    }
    this.close()
  }

  addNewConsultantOperate() {
    const dialogClient = this.dialog.open(
      ModalEmployeeConsultantOperationalClientNotAssociateComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '1200px',
        minWidth: '1200px',
        maxHeight: '650px',
        data: {
          item: { id: -1 },
          idClient: this.idClient,
          multiSelect: false,
        },
      },
    )
    dialogClient.componentInstance.responseSingle.subscribe((response: any) => {
      if (response) {
        console.log('response', response)
        if (response.associate == true && response.selection.id >= 0) {
          let model = {
            clienteId: this.idClient,
            funcionarioId: response.selection.id,
          }
          this.loadingAssociate = true
          this.employeeService.createAssociateClientsEmployee(model).subscribe({
            next: (responseAssociate: ResponseRequestModel) => {
              this.uploadList()
              this.loadingAssociate = false
            },
            error: (err: ResponseRequestModel) => {
              console.error(err)
              this.loadingAssociate = false
            },
            complete: () => {
              this.loadingAssociate = false
            },
          })
        }
      }
    })
  }

  editItem(event: any) {
    console.log('event', event)
  }

  deleteItem(event: any) {
    console.log('event', event)
  }
}
